module.exports = __webpack_public_path__ + "img/email.0b21bdd6.svg";